import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BoxDesign from './BoxDesign';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { IconRouting } from '../../Assets/panels/IconRouting';
import { LoadingColor } from '../LoadingColor';
import { IconTimer } from '../../Assets/panels/IconTimer';
import { IconHotels } from '../../Assets/panels/IconHotels';
import { IconResurant } from '../../Assets/panels/IconResurant';
import { IconAirplane } from '../../Assets/panels/IconAirplane';
import { IconBus } from '../../Assets/panels/IconBus';
import { IconShip } from '../../Assets/panels/IconShip';
import { CountriesShowByCode } from '../Inputs/CountriesShowByCode';
import { CitiesShowByCode } from '../Inputs/CitiesShowByCode';
const Styles = styled.div`
    width: 100%;
    .over-route {
        margin: 0rem 1rem 1rem;
        padding: 1.25rem;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .title-part {
            color: var(--text-h);
            display: flex;
            align-items: center;
            gap: 1rem;
            &.active {
                color: var(--main-color);
                .icon {
                    fill: var(--main-color);
                }
            }
            &.inside {
                color: #000000;
                .icon {
                    fill: var(--n-grey-2);
                }
            }
            .icon {
                fill: var(--text-h);
                width: 48px;
                height: 48px;
                display: block;
            }
            .text {
                font-weight: 700;
                font-size: 1.25rem;
            }
        }
        .line {
            height: 1px;
            background-color: var(--n-grey-1);
        }
        .box-routing {
            border-radius: var(--border-radius-3);
            background-color: var(--n-grey-01);
            padding: 1.5rem 2rem;
            display: flex;
            gap: 3rem;
            align-items: center;
            /* justify-content: space-between; */
            .line-h {
                align-self: normal;
                width: 2px;
                background-color: var(--n-grey-11);
                color: #FFFFFF00;
            }
            .data {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                .title {
                    font-size: 0.75rem;
                    font-weight: 500;
                    color: var(--n-grey-2);
                }
                .value {
                    font-size: 1.25rem;
                    font-weight: 500;
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        .over-route {
            .box-routing {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 0.5rem;
                row-gap: 1rem;
                align-items: center;
                justify-items: center;
                .data {
                    justify-self: start;
                }
            }
        }
    }
`




export default function TourDetailsFacilityCart ({loading = true, data, lang}){
    const makeFacility = (v, i) => {
        let item = "";
        let toppart = "";
        let isMobile = (window.innerWidth < 850) ? true : false;

        switch(v.Facility_Id) {
            case 1:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconAirplane className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
            case 2:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconBus className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
            case 3:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconBus className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
            case 4:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconShip className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
            case 5:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconResurant className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
            case 6:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconHotels className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
            default:
                toppart = (
                    <div className="title-part inside" key={i + "a"}>
                        <IconTimer className={"icon"}/>
                        <div className='text'>
                            {v.Facility_Name}
                        </div>
                    </div>
                )
                break;
        }
        let base = ""
        let baseData;
        if(typeof v.DESC !== "string"){
            base = "obj-";
            baseData = v.DESC
        }
        switch(base + v.Facility_Id) {
            case "obj-1":
                item = (
                    <>
                        {toppart}
                        <div className='box-routing' key={i + "b"}>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourAirline[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.airline}
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourAirport[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.airport}
                                </div>
                            </div>
                            {
                                (!isMobile) ? (
                                    <div className='line-h'>-</div>
                                ) : ""
                            }
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourCargo[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.cargo}
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourdistAirport[lang]}
                                </div>
                                <div className='value'>
                                    {baseData["airport-dest"]}
                                </div>
                            </div>
                        </div>
                    </>
                )
                break;
            case "obj-2":
                item = (
                    <>
                        {toppart}
                        <div className='box-routing' key={i + "b"}>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourStart[lang]}
                                </div>
                                <div className='value'>
                                    <CountriesShowByCode
                                        code={baseData["city1-country"]}
                                        lan={(lang !== "fa")}
                                    />
                                     - 
                                    <CitiesShowByCode
                                        code={baseData["city1"]}
                                        lan={(lang !== "fa")}
                                    />
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourEnd[lang]}
                                </div>
                                <div className='value'>
                                    <CountriesShowByCode
                                        code={baseData["city2-country"]}
                                        lan={(lang !== "fa")}
                                    />
                                     - 
                                    <CitiesShowByCode
                                        code={baseData["city2"]}
                                        lan={(lang !== "fa")}
                                    />
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourBus[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.bustype}
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourBoarding[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.boarding}
                                </div>
                            </div>
                            {
                                (!isMobile) ? (
                                    <div className='line-h'>-</div>
                                ) : ""
                            }
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourCargo[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.cargo}
                                </div>
                            </div>
                        </div>
                    </>
                )
                break;
            case "obj-3":
                item = (
                    <>
                        {toppart}
                        <div className='box-routing' key={i + "b"}>
                        <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourStart[lang]}
                                </div>
                                <div className='value'>
                                    <CountriesShowByCode
                                        code={baseData["city1-country"]}
                                        lan={(lang !== "fa")}
                                    />
                                     - 
                                    <CitiesShowByCode
                                        code={baseData["city1"]}
                                        lan={(lang !== "fa")}
                                    />
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourEnd[lang]}
                                </div>
                                <div className='value'>
                                    <CountriesShowByCode
                                        code={baseData["city2-country"]}
                                        lan={(lang !== "fa")}
                                    />
                                     - 
                                    <CitiesShowByCode
                                        code={baseData["city2"]}
                                        lan={(lang !== "fa")}
                                    />
                                </div>
                            </div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourTrain[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.traintype}
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourBoarding[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.boarding}
                                </div>
                            </div>
                            {
                                (!isMobile) ? (
                                    <div className='line-h'>-</div>
                                ) : ""
                            }
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourCargo[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.cargo}
                                </div>
                            </div>
                        </div>
                    </>
                )
                break;
            case "obj-4":
                item = (
                    <>
                        {toppart}
                        <div className='box-routing' key={i + "b"}>
                        <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourStart[lang]}
                                </div>
                                <div className='value'>
                                    <CountriesShowByCode
                                        code={baseData["city1-country"]}
                                        lan={(lang !== "fa")}
                                    />
                                     - 
                                    <CitiesShowByCode
                                        Country_Id={baseData["city1-country"]}
                                        code={baseData["city1"]}
                                        lan={(lang !== "fa")}
                                    />
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourEnd[lang]}
                                </div>
                                <div className='value'>
                                    <CountriesShowByCode
                                        code={baseData["city2-country"]}
                                        lan={(lang !== "fa")}
                                    />
                                     - 
                                    <CitiesShowByCode
                                        Country_Id={baseData["city2-country"]}
                                        code={baseData["city2"]}
                                        lan={(lang !== "fa")}
                                    />
                                </div>
                            </div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourShip[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.shiptype}
                                </div>
                            </div>
                            <div className='line-h'></div>
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourBoarding[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.boarding}
                                </div>
                            </div>
                            {
                                (!isMobile) ? (
                                    <div className='line-h'>-</div>
                                ) : ""
                            }
                            <div className='data'>
                                <div className='title'>
                                    {DictioneryPanel.packagesDict.tourCargo[lang]}
                                </div>
                                <div className='value'>
                                    {baseData.cargo}
                                </div>
                            </div>
                        </div>
                    </>
                )
                break;
            default:
                if(typeof v.DESC !== "string"){
                    item = (
                        <>
                            {toppart}
                            <div className='box-routing' key={i + "b"}>
                                <div className='data' style={{gridColumn: ((isMobile) ? "3 span" : "")}}>
                                    <div className='title'>
                                        {DictioneryPanel.packagesDict.tourDetailDesc[lang]}
                                    </div>
                                    <div className='value'>
                                        {v.DESC.desc}
                                    </div>
                                </div>
                                
                            </div>
                        </>
                    )
                } else {
                    item = (
                        <>
                            {toppart}
                            <div className='box-routing' key={i + "b"}>
                                {v.DESC}
                            </div>
                        </>
                    )
                }
                
                break;
        }
        return (
            <>
                {item}
                <div className='line' key={i + "c"}></div>
            </>
        )
    }
    const makeFacilities = () => {
        let details = data.DETAIL ? data.DETAIL : []
        return details.map(makeFacility)
    }
    if(loading){
        return (
            <Styles>
                <LoadingColor/>
            </Styles>
        )
    }
    return (
        <Styles>
            <BoxDesign className='over-route'>
                <div className="title-part active">
                    <IconRouting className={"icon"}/>
                    <div className='text'>
                        {DictioneryPanel.packagesDict.startTour[lang]} {"(" + data.City_Name_Source + ")"}
                    </div>
                </div>
                {makeFacilities()}
                <div className="title-part">
                    <IconRouting className={"icon"}/>
                    <div className='text'>
                        {DictioneryPanel.packagesDict.endTour[lang]} {"(" + data.City_Name_Source + ")"}
                    </div>
                </div>
            </BoxDesign>
        </Styles>
    )
}